import { useState } from 'react';
import { useMediaQuery } from '@mantine/hooks';
import { DESKTOP_DEFAULT, MOBILE_DEFAULT, ProductKey } from '../compareData';

const MOBILE_QUERY = '(max-width: 720px)';

/** Column selection state (3 desktop / 2 mobile); picking a shown collar swaps the two. */
export function useCompareColumns() {
  const isMobile = useMediaQuery(MOBILE_QUERY, false);
  const [desktopCols, setDesktopCols] = useState<ProductKey[]>(DESKTOP_DEFAULT);
  const [mobileCols, setMobileCols] = useState<ProductKey[]>(MOBILE_DEFAULT);

  const columns = isMobile ? mobileCols : desktopCols;
  const setColumns = isMobile ? setMobileCols : setDesktopCols;

  const selectColumn = (columnIndex: number, chosen: ProductKey) => {
    setColumns((prev) => {
      const next = [...prev];
      const existing = next.indexOf(chosen);
      if (existing !== -1 && existing !== columnIndex) {
        next[existing] = next[columnIndex];
      }
      next[columnIndex] = chosen;
      return next;
    });
  };

  return { columns, selectColumn };
}
